import React, { useState, useEffect } from 'react';



import { makeStyles } from '@material-ui/core/styles';

import {  useHistory } from 'react-router-dom';


import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

//import carsImage from 'public/img/cars.png'

import FavouriteData from './FavouriteData';

import SearchBox from './SearchBox';

import AppHeader from './AppHeader';

import "@fontsource/mulish"; // Defaults to weight 400.



var store = require('store')

const useStyles = makeStyles(theme => ({
    maincolumn: {        
        fontFamily:'Mulish', 
        fontWeight: '200',
        height:'100vh',
        //  backgroundColor: 'lightblue',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

    }, 
    grayColumn: {              
      
      backgroundColor: '#F3F3F3',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      width: '100%',
      marginTop: '5%',
      

  }, 
    resultsColumn: {         
      fontFamily:'Mulish', 
      fontWeight: '200',           
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      marginLeft: '5%',
      marginTop: '2%',
      marginBottom: '2%',
      

  }, 
  accordionColumn: {   
                 
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    marginLeft : '5%'
    

}, 
    searchRow: {
      fontFamily:'Mulish', 
      fontWeight: '200',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: '#E2F8F7',
      width: '100vw',
     
    }, 
    topWhiteRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center', 
      alignItems: 'center',
      minHeight: '30px',
      

    },
    imageRow: {
      // backgroundColor : 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      alignSelf: 'flex-end',
      
      maxWidth: '300px'

    }, 
    allDataButton: {      
      display: 'flex', 
      flexDirection: 'row', 
      justifyContent: 'flex-start', 
      alignItems: 'flex-start',
      marginTop: '5%',
      
    },
    primaryButton: {
      backgroundColor: '#5CD6D2',
      color: 'white',      
      fontWeight: 'bold',
      marginLeft: '2em',
      '&:hover': {
        backgroundColor: '#FFC24C',
        color: 'black',
      },
      // 
    }, 


    }));



function Home() {
  const [jsonObject, setJsonObject] = useState();

  const [searchValue, setSearchValue] = useState();
  const [searchError, setSearchError] = useState();

  const [token, setToken] = useState();
  const [tokenValidFrom, setTokenValidFrom] = useState();

  const [inProgress, setInProgress] = useState(false);
  
  const classes = useStyles();

  let history = useHistory();

  //console.log("match: " , match.params["carId"]);

  
  
  const fieldSet = LoadFieldsFromLocalStorage();
  
  function LoadFieldsFromLocalStorage() {
    var set = new Set();
    if (store.get("fieldSet"))
      set =new Set(JSON.parse(store.get("fieldSet")));

    return set;
  }

 

  function handleClick() {
    history.push("/AllData", {jsonObject: jsonObject, fieldSet: fieldSet});
       
  
  }


  function onSearch(value) {    

    if (tokenValidFrom && new Date().getTime() >= tokenValidFrom.getTime()) //token should be valid, search now
      setSearchValue(value);   
    else if (tokenValidFrom) {                                              //token will be valid in a few seconds, wait a bit
      var waitTime = tokenValidFrom.getTime()-new Date().getTime();
      console.log(`Token not valid yet, waiting ${waitTime} `);
      setTimeout(_=>setSearchValue(value), waitTime);
      setInProgress(true);
      setTimeout(_=>setInProgress(false), waitTime);
    }
    else {                                                                    //no tokenValidFrom is set, request a new token
      fetchToken();
      setSearchValue(null);
      // setTimeout(_=>onSearch(value), 5000);                               //wait a bit, perform new search
                                                            
    }
  }
 
  
  useEffect(() => {
    
    if (searchValue)
      fetchItems();  
    else if (!jsonObject) {  //handle cache
      try {
        const cachedJsonObject = JSON.parse(store.get("jsonObject"));
        if (cachedJsonObject)
        setJsonObject(cachedJsonObject);  //read cached jsonObject
      }
      catch {
        console.log("could not read cached jsonObject");
      }
      
      
    }
    
    
   
  },[searchValue])


  useEffect(() => { //run once, first time to get a token
    fetchToken();
    
  },[])

const fetchToken = async () => {   
  const res = await fetch(`https://cardetailsserver.azurewebsites.net/api/Home/getToken/`);    
  //const res = await fetch(`https://localhost:44301/api/Home/getToken/`);    
  
  const json = await res.json(); 
  
  ExtractAndSetToken(json);

}


const fetchItems = async () => {       
    
    setInProgress(true); 

    const res = await fetch(`https://cardetailsserver.azurewebsites.net/api/Home/getData/${searchValue}/${token}`);        
    //const res = await fetch(`https://localhost:44301/api/Home/getData/${searchValue}/${token}`);    
    
    setInProgress(false);

    console.log("searched for ", searchValue)

    try {
      setSearchError(null);
      setJsonObject(null);      
      const resData = await res.json();      

      //console.log("response: ", resData);

      ExtractAndSetToken(resData);


      if (resData["kjoretoydataListe"]) { //found vehicle
        const kjoretoyObj = resData["kjoretoydataListe"][0];
        
        setJsonObject(kjoretoyObj);          
        SetCachedJsonObject(kjoretoyObj);
      }
      else if (resData["errorCode"]=='20') { //no vehicle found
        setSearchError(`Ingen kjøretøy ble funnet med registreringsnummer eller VIN = ${searchValue}`);
    
      }
      else if (resData["errorCode"]=='10') { //token error
        setSearchError(`Token var ikke gyldig, vennligst vent noen sekunder og forsøk igjen`);
        setSearchValue(null);
   
       
      }
    }

    catch {    
      setSearchError(`Ingen kjøretøy ble funnet med registreringsnummer eller VIN = ${searchValue}`);
      SetCachedJsonObject(null);
    }

    
    
}


  
  return (  

    <div>     

      <AppHeader backButton={false}/>

      <div className={classes.topWhiteRow}>

        <div className={classes.searchRow}>
        
          <SearchBox onSearch={onSearch} inProgress={inProgress}/>

          <div className={classes.imageRow}>
            <img src={window.location.origin + '/img/cars.png'} alt={"carImage"} width='80%' height='80%'  /> 
          </div>

        </div>
      </div>
    
    <div className={classes.maincolumn} >          
  
      <div className={classes.grayColumn}>

        <div className={classes.resultsColumn}>
                  
          {searchError && <div>{searchError}</div>}

          <FavouriteData jsonObject={jsonObject} fieldSet={fieldSet}/>                             
          
        </div>                     

      </div>

      { jsonObject && <div className={classes.allDataButton} >
        <Button  variant="contained" color="primary" className={classes.primaryButton} onClick={handleClick} >
            Alle Data
        </Button>     
      </div>      
      }
        

        
     
    </div>
  
    </div>
  

    

  );

  function ExtractAndSetToken(json) {
    try {
      if (json["token"]) {
        const newToken = json["token"];
        setToken(newToken);    
        var dateTime = new Date();
        setTokenValidFrom(new Date(dateTime.getTime() + 5000));
        //console.log("received new token:", newToken);
      }
    }
    catch {
      console.log("New token could not be extracted and set");
    }
  }

  function SetCachedJsonObject(kjoretoyObj) {
    store.set("jsonObject", JSON.stringify(kjoretoyObj));
  }
}





export default Home;
